export default {
  root: {
    fontSize: 'inherit'
  }
};
